import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideContrast,
} from "../GuideBlocks.js";

const MentalClarityVsMindfulnessSection = ({ heading, accentIndex = 0 }) => (
  <GuidePanel sectionId="mental-clarity-vs-mindfulness" heading={heading} accentIndex={accentIndex}>
    <GuideLead>These concepts are related but not identical.</GuideLead>
    <GuideCompare
      leftTitle="Mindfulness"
      rightTitle="Mental Clarity"
      left={
        <>
          <p>The practice of paying attention to the present moment without judgment.</p>
          <p><strong>It develops awareness.</strong></p>
        </>
      }
      right={
        <>
          <p>The outcome of awareness combined with structured thinking.</p>
          <p>It enables better judgment, better communication, and better decisions.</p>
        </>
      }
    />
    <GuideCallout>
      You can practice mindfulness and still struggle with decision-making if you have not learned to examine
      assumptions, organize your thinking, and regulate emotional reactions.
    </GuideCallout>
    <GuideContrast
      items={[
        { title: "Mindfulness helps you notice.", text: "Awareness of what is happening inside." },
        { title: "Mental clarity helps you decide.", text: "Structure to act on what you notice." },
      ]}
    />
    <p className="guide-panel__p">
      Noticing a thought is the first step, not the last. If you observe "they ignored my email" and
      stop there, the interpretation remains untested and returns tomorrow. Clarity comes from the next
      two steps: asking what evidence supports the thought, and choosing a response based on that
      evidence. Awareness opens the door; structured examination walks through it.
    </p>
  </GuidePanel>
);

export default MentalClarityVsMindfulnessSection;
